<template>
  <div>
    <el-dialog
      title="申请分批发货"
      :visible.sync="dialogVisible"
      width="90%"
      top="5vh"
      class="partShipment"
      @close="closeDialog"
    >
      <div>
        产品信息
        <div class="text-red-500 mt-2.5">
          注：<br>1.货运方式为供应商直发的产品预计在提交申请三天后发货。<br>2.同一个收货地址的运输方式、承运商要保持一致。
        </div>
      </div>

      <div class="action-box">
        <el-button type="primary" @click="handleSettingProductAddress">批量设置勾选产品收货地址(多地址)</el-button>
        <span>运输方式：</span>
        <el-radio-group v-model="modeOfShippingRadio" @change="handleChangeRadiomodeOfShipping">
          <el-radio label="陆运">陆运</el-radio>
          <el-radio label="航空">航空</el-radio>
        </el-radio-group>
        <span>承运商：</span>
        <el-select v-model="carrierSelect" :disabled="carrierSelectDis">
          <el-option v-for="item in carrierSelectList" :key="item.key" :label="item.value" :value="item.key" />
        </el-select>
        <el-button type="primary" class="ml-4" @click="handleSettingProductExt">批量设置勾选产品运输方式及承运商</el-button>
      </div>

      <div class="table-box">
        <div v-for="(item, index) in newProductList" :key="index" class="table-item">
          <div class="table-title">
            <span>原收货地址： {{ item.address }}</span>
            <span>原运输方式： {{ item.modelOfShipping }}</span>
            <span>原承运商： {{ item.carrier }}</span>
          </div>
          <div class="table-inner">
            <el-table
              :data="item.productList"
              border
              class="w-full"
              show-summary
              :summary-method="getSummaries"
              @selection-change="(selection) => handleSelectionChange(selection, item.productList)"
            >
              <el-table-column
                type="selection"
                width="50"
              />
              <el-table-column
                prop="itemIndex"
                label="序号"
                align="left"
                width="90"
              />
              <el-table-column prop="orderNumber" label="订单号" align="left" />
              <el-table-column
                prop="materialNumber"
                label="物品代码"
                align="left"
              />
              <el-table-column prop="productName" label="物品名称" align="left" />
              <el-table-column prop="productNum" label="数量" align="left" width="60px" />
              <el-table-column
                prop="productPriceSigle"
                label="实际结算单价"
                align="right"
                header-align="left"
                width="100px"
              />
              <el-table-column
                prop="settlementAmount"
                label="实际结算金额"
                align="right"
                header-align="left"
                width="100px"
              />
              <el-table-column
                prop="FreightAttributeName"
                label="货运方式"
                align="left"
                width="100"
              />
              <el-table-column
                prop="expectedDeliveryDate"
                label="客户期望发货日"
                align="left"
                width="140"
              >
                <template v-slot="{row}">
                  {{ row.expectedDeliveryDate && row.expectedDeliveryDate.substr(0,11) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="agreedDate"
                label="约定交付日期"
                align="left"
                width="140"
              >
                <template v-slot="{row}">
                  {{ row.agreedDate && row.agreedDate.substr(0,11) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="deliveryAddress"
                label="收货地址"
                align="left"
                width="200"
              />
              <el-table-column
                prop="modeOfShipping"
                label="运输方式"
                align="left"
                width="100"
              />
              <el-table-column
                prop="carrier"
                label="承运商"
                align="left"
                width="100"
              />
              <el-table-column
                label="操作"
                align="left"
                width="100"
              >
                <template v-slot="{ row, $index }">
                  <el-button type="text" @click="singleAddress(row, $index)">
                    更改地址
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <DialogAddressInnerProduct ref="DialogAddressInnerProductRef" />
      <div class="advanceMakeDeatail">
        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否需要唛头：
              </div>
              <div class="rj-baseinfo__item">
                <el-radio-group v-model="markType">
                  <el-radio
                    v-for="(item, index) in makeList"
                    :key="index"
                    :label="item.value"
                  >
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                <span v-if="isRequiredEmail" class="required-tip">*</span>
                授权邮箱：
              </div>
              <div class="rj-baseinfo__item">
                <el-input
                  v-model.trim="
                    findContractInfoForPartialInvoiceMessage.authorizationEmail
                  "
                  class="w-50"
                  placeholder="请输入授权邮箱"
                />
              </div>
            </div>
          </div>
          <!--          <div class="rj-col-2">-->
          <!--            <div class="rj-baseinfo">-->
          <!--              <div class="rj-baseinfo__label">-->
          <!--                是否有特殊回单：-->
          <!--              </div>-->
          <!--              <div class="rj-baseinfo__item">-->
          <!--                <el-radio-group v-model="tshdType">-->
          <!--                  <el-radio-->
          <!--                    v-for="(item, index) in tshdList"-->
          <!--                    :key="index"-->
          <!--                    :label="item.value"-->
          <!--                  >-->
          <!--                    {{ item.label }}-->
          <!--                  </el-radio>-->
          <!--                </el-radio-group>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <p>
        <span class="inline-block my-1">收货回执及到货验收要求：</span>
        <el-input
          v-model.trim="
            findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements
          "
          type="textarea"
          :rows="3"
          placeholder="请输入收货回执及到货验收要求"
          maxlength="200"
          show-word-limit
        />
      </p>
      <p>
        <span>回执附件</span>
        <el-upload
          action=""
          multiple
          :show-file-list="false"
          :http-request="uploadaction"
          class="inline-block mx-2.5"
        >
          <el-button type="primary">
            上传附件
          </el-button>
        </el-upload>
      </p>
      <!--   附件列表   -->
      <el-table
        :data="fileList"
        border
        class="w-full"
      >
        <el-table-column prop="receiptNum" label="回执单号" align="left" />
        <el-table-column prop="fileName" label="附件名称" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleShowFile(row)">
              {{ row.fileName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="上传人" align="left" />
        <el-table-column prop="createTime" label="上传时间" align="left" />
        <el-table-column label="操作" align="left">
          <template v-slot="{row, $index}">
            <el-button type="text" @click="handleShowFile(row)">
              查看
            </el-button>
            <el-button type="text" @click="handleDeleteFile($index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <p>
        <span class="inline-block my-1">发货备注说明：</span>
        <el-input
          v-model.trim="
            findContractInfoForPartialInvoiceMessage.deliverRemark
          "
          type="textarea"
          :rows="3"
          placeholder="请输入发货备注说明"
          maxlength="200"
          show-word-limit
        />
      </p>
      <p>
        <span class="inline-block my-1">备注：</span>
        <el-input
          v-model.trim="findContractInfoForPartialInvoiceMessage.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          maxlength="200"
          show-word-limit
        />
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="handleCancle">取消申请</el-button>
        <el-button
          :loading="subLoading"
          type="primary"
          @click="submit"
        >提交</el-button>
      </span>
    </el-dialog>
    <addressBox :prop-open.sync="addressIsShow" @chooseAddress="changeAddress" />
  </div>
</template>

<script>
import { formatDate, MathAdd } from '@/libs/util';
import addressBox from '@/views/address/index.vue';
import AxiosApi from '@/API/fileAxios';
import {
  attachmentGetToken,
  receiptAttachmentCreateNewReceiptNumber,
  receiptAttachmentGetAddressGroupList,
  receiptAttachmentCheckAddressInfo,
  savePartialShipment,
  receiptAttachmentGetEditInfo, businessConfirmApplyPartialShipment
} from '@/API';
import { mailboxVerification } from '@/API/international';
import DialogAddressInnerProduct from './DialogAddressInnerProduct.vue';
import { checkPartialShipmentCompliance } from '@/libs/partialShipmentCompliance';
export default {
  name: 'DialogMoreAddress',
  inject: {
    contractSingleInfo: { default: () => () => ({}) }
  },
  components: { addressBox, DialogAddressInnerProduct },
  data () {
    return {
      /** 弹窗显示状态 */
      dialogVisible: false,
      /** 分批发货申请的详细信息对象 */
      findContractInfoForPartialInvoiceMessage: {
        authorizationEmail: '', // 授权邮箱
        receiptArrivalAcceptanceRequirements: '', // 收货回执及到货验收要求
        deliverRemark: '', // 发货备注说明
        remark: '' // 备注
      },
      /** 授权邮箱是否必填 */
      isRequiredEmail: false,
      /** 回执附件列表 */
      fileList: [],
      /** 文件上传/下载的 token */
      token: '',
      /** 文件上传 URL */
      uploadUrl: '',
      /** 文件下载 URL */
      downFileUrl: '',
      /** 提交按钮的 loading 状态 */
      subLoading: false,
      /** 勾选产品的 itemIndex 一维数组，用于批量操作 */
      selectedItemIndexList: [],
      /** 运输方式单选值：陆运/航空 */
      modeOfShippingRadio: '陆运',
      /** 承运商选择值 */
      carrierSelect: '默认物流',
      /** 承运商下拉选项列表 */
      carrierSelectList: [
        {
          key: '默认物流',
          value: '默认物流'
        }, {
          key: '顺丰',
          value: '顺丰'
        }
      ],
      /** 是否需要唛头 */
      markType: false,
      /** 唛头选项列表 */
      makeList: [
        { value: true, label: '是' },
        { value: false, label: '否' }
      ],
      /** 是否有特殊回单 */
      tshdType: '0',
      /** 特殊回单选项列表 */
      tshdList: [
        {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }
      ],
      /** 承运商下拉框是否禁用（航空时禁用） */
      carrierSelectDis: false,
      /** 地址选择弹窗显示状态 */
      addressIsShow: false,
      /** 按地址分组后的产品列表数据 */
      newProductList: [],
      /** 地址编辑操作的上下文信息 */
      addressAction: {
        type: '', // 操作类型：all-批量设置，single-单行修改
        actionRow: null // 单行修改时的目标行数据
      },
      /** 最后选择的收货地址 ID */
      lasterAddressId: null,
      /** 是否为编辑模式（true-编辑已有申请，false-新建申请） */
      editFlag: false,
      /** 编辑模式下的原始数据对象 */
      editInfoObj: null
    };
  },
  methods: {
    // 打开弹窗
    openDialog (list) {
      this.editFlag = false;
      if (!list.length) return;
      this.checkEmailIsRequired(list);
      receiptAttachmentGetAddressGroupList({ partialInvoiceProductList: list }).then(res => {
        const json = res.data;
        if (json.status === '200') {
          this.newProductList = json.data.partialInvoiceAddressGroupList;
          this.dialogVisible = true;
          this.initToken();
          setTimeout(() => {
            this.$refs.DialogAddressInnerProductRef.setData(this.newProductList);
          }, 100);
        }
      });
    },
    // 验证邮箱是否需要必填
    checkEmailIsRequired (array) {
      let params = array.map((item) => item.materialNumber);
      mailboxVerification(params)
        .then(res => {
          let { status, data } = res.data;
          if (status === '200') {
            this.isRequiredEmail = data;
          }
        });
    },
    openEditDialog (row) {
      this.editFlag = true;
      receiptAttachmentGetEditInfo(row.id).then(res => {
        const json = res.data;
        this.editInfoObj = json.data;
        if (json.status === '200') {
          this.findContractInfoForPartialInvoiceMessage.authorizationEmail = json.data.partialInvoiceDetail.authorizationEmail || '';
          this.findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements = json.data.partialInvoiceDetail.receiptArrivalAcceptanceRequirements || '';
          this.findContractInfoForPartialInvoiceMessage.deliverRemark = json.data.partialInvoiceDetail.deliverRemark || '';
          this.findContractInfoForPartialInvoiceMessage.remark = json.data.partialInvoiceDetail.remark || '';
          this.markType = json.data.partialInvoiceDetail.markType;
          this.lasterAddressId = json.data.partialInvoiceDetail.receiptAddressId || null;
          this.newProductList = json.data.partialInvoiceAddressGroupList || [];
          this.fileList = json.data.reversedInvoiceVO || [];
          this.dialogVisible = true;
          this.initToken();
          setTimeout(() => {
            this.$refs.DialogAddressInnerProductRef.setData(this.newProductList);
          }, 100);
        }
      });
    },
    // 关闭弹窗
    closeDialog () {
      this.fileList = [];
      this.findContractInfoForPartialInvoiceMessage.remark = '';
      this.findContractInfoForPartialInvoiceMessage.deliverRemark = '';
      this.findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements = '';
      this.findContractInfoForPartialInvoiceMessage.authorizationEmail = '';
      this.markType = false;
      this.dialogVisible = false;
      this.subLoading = false;
    },
    // 每个表格的小计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },

    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      return cont;
    },
    // 实际结算金额总计
    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    // 表格的选中行事件
    handleSelectionChange (selection, tableRows = []) {
      // 获取表格的所有行的 itemIndex
      const tableIndexes = tableRows
        .map(row => row.itemIndex)
        .filter(index => index);
      // 先从全局选中列表中 当前这张表 的所有 itemIndex，目的是清除这张表之前的勾选痕迹，避免产留老数据
      this.selectedItemIndexList = this.selectedItemIndexList.filter(index => !tableIndexes.includes(index));
      // 去除这张表 被选中 的行的 itemIndex
      const currentSelectionIndexes = selection
        .map(row => row.itemIndex)
        .filter(index => index);
      // 把当前表实际选中的 itemIndex 追加回全局选中列表，此时全局列表中既有别的表的选中项，又有这张表的最新选中项
      this.selectedItemIndexList.push(...currentSelectionIndexes);
    },
    // 批量设置多地址
    handleSettingProductAddress () {
      if (!this.selectedItemIndexList.length) return this.$message.error('请先勾选产品');
      this.addressIsShow = true;
      this.addressAction.type = 'all';
    },
    changeAddress (val) {
      this.addressIsShow = false;
      this.lasterAddressId = val.id;
      const _deliveryAddress = `${val.province}${val.city}${val.county}${val.receiptAddress}${val.receiverName}${val.receiverPhone}`;
      if (this.addressAction.type === 'single') {
        this.addressAction.actionRow.deliveryAddress = _deliveryAddress;
        return;
      }
      this.newProductList.forEach(item => {
        item.productList.forEach(it => {
          if (this.selectedItemIndexList.includes(it.itemIndex)) {
            it.deliveryAddress = _deliveryAddress;
          }
        });
      });
    },
    singleAddress (row) {
      this.addressAction.type = 'single';
      this.addressAction.actionRow = row;
      this.addressIsShow = true;
    },
    // 批量设置运输方式及承运商
    handleSettingProductExt () {
      if (!this.selectedItemIndexList.length) return this.$message.error('请先勾选产品');
      // 根据 selectedItemIndexList + modeOfShippingRadio + carrierSelect 做批量设置
      this.newProductList.forEach(item => {
        item.productList.forEach(it => {
          if (this.selectedItemIndexList.includes(it.itemIndex)) {
            it.modeOfShipping = this.modeOfShippingRadio;
            it.carrier = this.carrierSelect;
          }
        });
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      });
    },
    // 上传回执附件
    async uploadaction (upload) {
      if (this.fileList.findIndex(item => item.fileName === upload.file.name) !== -1) {
        this.$message.error(`文件“${upload.file.name}”已存在，请勿重复上传.`);
        return;
      }
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      // 获取回执单号
      const { data: receiptResult } = await receiptAttachmentCreateNewReceiptNumber();
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          let _date = new Date();
          const _item = {
            receiptNum: receiptResult.data.receiptNum || '',
            fileToken: json.data[0].FID,
            fileName: json.data[0].FullName,
            createBy: this.$store.state.user.userName,
            createTime: formatDate(_date, 'yyyy-MM-dd hh:mm:ss')
          };
          this.fileList.push(_item);
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    // 查看文件
    handleShowFile (row) {
      const url = `${this.downFileUrl}/${row.fileToken}?Token=${this.token}`;
      window.open(url, '_blank');
    },
    // 移除文件
    handleDeleteFile (index) {
      // 二次确认是否删除
      this.$confirm('确定删除该附件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileList.splice(index, 1);
      });
    },
    getSubmitData () {
      const _amountSum = this.newProductList.reduce((total, item) => {
        return total + Number(this.settlementAmount(item.productList));
      }, 0);
      let params = {
        masterContractId: this.$route.query.id,
        masterContractNum: this.$route.params.contractNum,
        masterProjectName: this.$route.query.masterProjectName,
        detail: {
          id: null,
          partialId: null,
          receiptAddressId: this.lasterAddressId,
          partialAddressId: this.lasterAddressId,
          modeOfShipping: null,
          carrier: null,
          freight: null,
          freightPayType: 0,
          freightUseRebate: null,
          amountSum: _amountSum.toFixed(2),
          remark: this.findContractInfoForPartialInvoiceMessage.remark,
          deliverRemark: this.findContractInfoForPartialInvoiceMessage.deliverRemark,
          receiptArrivalAcceptanceRequirements: this.findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements,
          authorizationEmail: this.findContractInfoForPartialInvoiceMessage.authorizationEmail,
          approvalOpinion: '',
          markType: this.markType
        },
        partialInvoiceProductList: this.newProductList.map(item => item.productList).flat(),
        rebateListVo: null,
        partialInvoiceFile: this.fileList
      };
      return params;
    },
    handleCancle () {
      this.fileList = [];
      this.findContractInfoForPartialInvoiceMessage.remark = '';
      this.findContractInfoForPartialInvoiceMessage.deliverRemark = '';
      this.findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements = '';
      this.findContractInfoForPartialInvoiceMessage.authorizationEmail = '';
      this.markType = false;
      this.dialogVisible = false;
      this.subLoading = false;
    },
    async handleEditFunc () {
      const _amountSum = this.newProductList.reduce((total, item) => {
        return total + Number(this.settlementAmount(item.productList));
      }, 0);
      if (this.isRequiredEmail) {
        if (!this.findContractInfoForPartialInvoiceMessage.authorizationEmail) {
          this.$message.error('授权邮箱为必填项，请填写后再提交');
          this.subLoading = false;
          return;
        }
      }
      const params = this.getSubmitData();
      receiptAttachmentCheckAddressInfo(params).then(async res => {
        if (res.data.status !== '200') {
          this.subLoading = false;
          return;
        }
        let paramsTwo = {
          partialId: this.editInfoObj.partialInvoiceDetail.partialId, // 分批发货id
          masterContractId: this.editInfoObj.partialInvoiceInfo.masterContractId, // 主（原）合同主键
          masterContractNum: this.editInfoObj.partialInvoiceInfo.masterContractNum, // 合同号
          masterProjectName: this.editInfoObj.partialInvoiceInfo.masterProjectName, // 项目名称
          partialInvoiceFile: this.fileList,
          partialInvoiceProductList: this.newProductList.map(item => item.productList).flat(), // 申请的部分发货产品列表
          detail: {
            amountSum: _amountSum.toFixed(2),
            remark: this.findContractInfoForPartialInvoiceMessage.remark,
            deliverRemark: this.findContractInfoForPartialInvoiceMessage.deliverRemark,
            receiptArrivalAcceptanceRequirements: this.findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements,
            authorizationEmail: this.findContractInfoForPartialInvoiceMessage.authorizationEmail,
            approvalOpinion: '',
            markType: this.markType,
            id: this.editInfoObj.partialInvoiceDetail.id,
            partialId: this.editInfoObj.partialInvoiceDetail.partialId,
            partialAddressId: this.editInfoObj.partialInvoiceDetail.partialAddressId, // 发货单收货地址id
            receiptAddressId: this.editInfoObj.partialInvoiceDetail.receiptAddressId // 主（原）收货地址id
          }
        };
        const addresses = this.newProductList.map(item => item.receiptAddressInfo || item.address || item);
        try {
          const canSubmit = await checkPartialShipmentCompliance({
            businessScene: 'DOMESTIC_PARTIAL_SHIPMENT_BUSINESS_SUBMIT',
            originalBizId: paramsTwo.partialId,
            contractInfo: this.editInfoObj.partialInvoiceInfo || {},
            addresses,
            products: paramsTwo.partialInvoiceProductList,
            projectName: paramsTwo.masterProjectName
          });
          if (!canSubmit) {
            this.subLoading = false;
            return;
          }
        } catch (error) {
          this.subLoading = false;
          this.$message.error(error.message || '出口合规检测失败');
          return;
        }
        businessConfirmApplyPartialShipment(paramsTwo).then(res => {
          const subJson = res.data;
          if (subJson.status === '200') {
            this.subLoading = false;
            this.dialogVisible = false;
            // 关闭弹窗的一些操作
            this.$emit('successSubmit');
          } else {
            this.subLoading = false;
          }
        });
      }).catch(_ => {
        this.subLoading = false;
      });
    },
    async submit () {
      this.subLoading = true;
      if (this.editFlag) {
        this.handleEditFunc();
        return;
      }
      if (this.isRequiredEmail) {
        if (!this.findContractInfoForPartialInvoiceMessage.authorizationEmail) {
          this.$message.error('授权邮箱为必填项，请填写后再提交');
          this.subLoading = false;
          return;
        }
      }
      const params = this.getSubmitData();
      receiptAttachmentCheckAddressInfo(params).then(res => {
        if (res.data.status !== '200') {
          this.subLoading = false;
          return;
        }
        const addresses = this.newProductList.map(item => item.receiptAddressInfo || item.address || item);
        checkPartialShipmentCompliance({
          businessScene: 'DOMESTIC_PARTIAL_SHIPMENT_CHANNEL_SUBMIT',
          originalBizId: params.masterContractNum || params.masterContractId,
          contractInfo: this.contractSingleInfo(),
          addresses,
          products: params.partialInvoiceProductList,
          projectName: params.masterProjectName
        }).then(canSubmit => {
          if (!canSubmit) {
            this.subLoading = false;
            return null;
          }
          return savePartialShipment(params);
        }).then(subRes => {
          if (!subRes) return;
          const subJson = subRes.data;
          if (subJson.status === '200') {
            this.subLoading = false;
            this.dialogVisible = false;
            // 关闭弹窗的一些操作
            this.$emit('successSubmit');
          } else {
            this.subLoading = false;
          }
        }).catch(error => {
          this.subLoading = false;
          if (error && error.message) this.$message.error(error.message);
        });
      }).catch(_ => {
        this.subLoading = false;
      });
    },
    // 运输方式单选框回调
    handleChangeRadiomodeOfShipping (val) {
      this.carrierSelect = '默认物流';
      if (val === '航空') {
        this.carrierSelectDis = true;
      } else {
        this.carrierSelectDis = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.partShipment p {
  margin: 5px 0;
}
.required-tip{
  color: red;
}
::v-deep .el-dialog__body{
  padding: 16px;
  height: 78vh;
  overflow-y: auto;
}
.table-box{
  .table-item{
    margin-top: 16px;
    border: 1px solid #EBEEF5;
    .table-title{
      padding: 8px 16px 8px 8px;
      span{
        margin-right: 32px;
      }
    }
  }
}
.action-box{
  margin-top: 16px;
  span{
    margin-left: 16px;
  }
}
</style>
